import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IHeader } from '../_shared/models/header.model';
import { GridComponent } from '../grid/grid.component';
import { TextHtmlParagraphComponent } from '../text-html/text-html-paragraph.component';
import { HeadingComponent } from '../heading/heading.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sirius-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, TextHtmlParagraphComponent, HeadingComponent, CommonModule]
})
export class HeaderComponent implements OnInit, IDynamicElement {
    @Input() config?: IHeader;
    @Input() title = '';
    @Input() subtitleHtml = ''; // TODO: Rename to textHtml
    @Input() textAlignment: 'textLeft' | 'textCenter' = 'textCenter';

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.subtitleHtml = this.config.subTitleHtml;
            this.textAlignment = this.config.textAlignment;
        }
    }
}
